// Action to toggle the tutorial state
export const toggleTutorial = () => {
  return {
    type: 'TOGGLE_TUTORIAL', // Action type
  };
};

// Action to explicitly set the tutorial state (expanded or collapsed)
export const setTutorialExpanded = (isExpanded) => {
  return {
    type: 'SET_TUTORIAL_EXPANDED', // Action type
    payload: isExpanded, // Pass the new state as payload
  };
};